export default class Authors extends Component {
  render() {
    const Header = props => (
      <Text
        marginBottom={2}
        textTransform="uppercase"
        fontWeight={400}
        color="rgba(0, 0, 0, 0.5)"
        fontSize={10}
        {...props}
      />
    )

    return (
      <Surface>
        <Surface flexFlow="row">
          <Surface>
            <Header>Authors</Header>
            <Text marginY={2} fontWeight={600}>
              Nick Cammarata
            </Text>
            <Text marginY={2} fontWeight={600}>
              Chris Olah
            </Text>
          </Surface>

          <Surface marginX={70}>
            <Header>Affiliations</Header>
            <Text marginY={2}>OpenAI</Text>
            <Text marginY={2}>OpenAI</Text>
          </Surface>

          <Surface>
            <Header>Published</Header>
            <Text marginY={2}>Not Yet</Text>
          </Surface>
        </Surface>
        <Surface
          border
          padding={5}
          marginY={15}
          borderRadius={5}
          width={370}
          background="rgba(0, 0, 0, 0.01)"
          alignItems="center"
          justifyContent="center"
        >
          <Text size={400} fontWeight={500} opacity={0.6}>
            Authors are not finalized. This is just a placeholder.
          </Text>
        </Surface>
      </Surface>
    )
  }
}
